/**
 * Main /products/iron-therapy — location UX, serve anchor, hero → Servicify booking bridge.
 * Scoped to iron-therapy handle only (not state products or Ads LPs).
 */
(function () {
  var MOBILE_VALUE = 'Mobile Services - All of New York City and Long Island';
  var MOBILE_LABEL = 'Mobile Service';
  var LOCATION_ORDER = [MOBILE_VALUE, 'Queens in office', 'Long Island in office'];

  function isMainIronPage() {
    return document.body && document.body.classList.contains('template-product') &&
      /\/products\/iron-therapy\/?$/.test(window.location.pathname);
  }

  function labelForLocation(value) {
    return value === MOBILE_VALUE ? MOBILE_LABEL : value;
  }

  function reorderHeroModalOptions(modal) {
    if (!modal) return;
    modal.querySelectorAll('.product-option').forEach(function (group) {
      var label = group.querySelector('label');
      if (!label || !/location|service|title/i.test(label.textContent)) return;
      var inputs = Array.from(group.querySelectorAll('.variant-input'));
      if (!inputs.length) return;
      var byValue = {};
      inputs.forEach(function (wrap) {
        var input = wrap.querySelector('input[type="radio"]');
        if (input) byValue[input.value] = wrap;
      });
      if (!byValue[MOBILE_VALUE]) return;
      LOCATION_ORDER.forEach(function (val) {
        if (byValue[val]) group.appendChild(byValue[val]);
      });
      inputs.forEach(function (wrap) {
        var input = wrap.querySelector('input[type="radio"]');
        if (!input) return;
        var lab = wrap.querySelector('label');
        if (lab) lab.textContent = labelForLocation(input.value);
      });
    });
  }

  function preselectMobileInHeroModal(modal) {
    if (!modal) return;
    var mobile = modal.querySelector('input[type="radio"][value="' + MOBILE_VALUE.replace(/"/g, '\\"') + '"]');
    if (mobile && !mobile.checked) {
      mobile.checked = true;
      mobile.dispatchEvent(new Event('change', { bubbles: true }));
      var mobileLabel = modal.querySelector('label[for="' + mobile.id + '"]');
      if (mobileLabel) mobileLabel.click();
    }
  }

  function getSelectedOptionsFromHeroModal(modal) {
    var options = [];
    modal.querySelectorAll('.product-option').forEach(function (group) {
      var checked = group.querySelector('input[type="radio"]:checked');
      options.push(checked ? checked.value : null);
    });
    return options;
  }

  function resolveVariantIdFromOptions(selectedOptions) {
    var variants = window.meta && window.meta.product && window.meta.product.variants;
    if (!variants || !selectedOptions.length) return null;
    var match = variants.find(function (v) {
      var parts = (v.public_title || v.name || '').split(' / ');
      return selectedOptions.every(function (opt, i) {
        return !opt || parts[i] === opt;
      });
    });
    return match ? match.id : null;
  }

  function syncToFeaturedProductForm(selectedOptions, variantId) {
    var root = document.querySelector('#custom__product-variant-desk') ||
      document.querySelector('.featured-product');
    if (!root) return false;

    selectedOptions.forEach(function (val, idx) {
      if (!val) return;
      var esc = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(val) : val.replace(/"/g, '\\"');
      var selector = 'input[type="radio"][data-variant-input][data-index="option' + (idx + 1) + '"][value="' + esc + '"]';
      var input = root.querySelector(selector);
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    if (!variantId) variantId = resolveVariantIdFromOptions(selectedOptions);

    var idInput = root.querySelector('form.product-single__form [name="id"], form [name="id"]');
    if (idInput && variantId) idInput.value = variantId;

    if (variantId) {
      var productEl = root.querySelector('[data-product-id]');
      var productId = productEl && productEl.getAttribute('data-product-id');
      document.dispatchEvent(new CustomEvent('servicify-variant-change', {
        detail: { variantId: Number(variantId), productId: productId ? Number(productId) : undefined }
      }));
    }
    return true;
  }

  function findMatchingVariantId(modal, selectedOptions) {
    var raw = modal.querySelector('textarea');
    if (!raw) return null;
    try {
      var variants = JSON.parse(raw.value || '[]');
      var match = variants.find(function (v) {
        if (!v.options || !selectedOptions.length) return false;
        return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
      });
      return match ? match.id : null;
    } catch (e) {
      return null;
    }
  }

  function openServicifyBooking() {
    var eaBtn = document.querySelector('#custom__product-variant-desk .easy_appointment_custom') ||
      document.querySelector('.featured-product .easy_appointment_custom') ||
      document.querySelector('button.easy_appointment_custom');
    if (eaBtn) {
      eaBtn.click();
      return true;
    }
    return false;
  }

  function startHeroBookingFlow() {
    var mobileOptions = [MOBILE_VALUE, 'Single'];
    syncToFeaturedProductForm(mobileOptions, null);

    var root = document.querySelector('#custom__product-variant-desk') || document.querySelector('.featured-product');
    if (root) {
      var mobileRadio = root.querySelector('input[type="radio"][data-variant-input][value="' + MOBILE_VALUE.replace(/"/g, '\\"') + '"]');
      if (mobileRadio && !mobileRadio.checked) {
        mobileRadio.checked = true;
        mobileRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    var bookingSection = document.querySelector('#custom__product-variant-desk');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    setTimeout(function () {
      openServicifyBooking();
    }, 450);
  }

  function wireHeroBookingBridge() {
    document.querySelectorAll('[data-section-type="slideshow-section"] [data-test-book-btn]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        startHeroBookingFlow();
      }, true);
    });

    function handleHeroModalBooking(addBtn) {
      var modal = addBtn.closest('.test-modal');
      if (!modal) return false;

      var selectedOptions = getSelectedOptionsFromHeroModal(modal);
      var variantId = findMatchingVariantId(modal, selectedOptions);

      modal.classList.remove('show');
      syncToFeaturedProductForm(selectedOptions, variantId);

      var bookingSection = document.querySelector('#custom__product-variant-desk');
      if (bookingSection) {
        bookingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      setTimeout(function () {
        openServicifyBooking();
      }, 400);
      return true;
    }

    document.querySelectorAll('.test-modal [name="add"].add-to-cart').forEach(function (addBtn) {
      addBtn.setAttribute('type', 'button');
      addBtn.addEventListener('click', function (e) {
        if (!isMainIronPage()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        handleHeroModalBooking(addBtn);
      }, true);
    });

    document.querySelectorAll('form.product-single__form_shop_all').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!isMainIronPage()) return;
        var submitter = e.submitter;
        if (submitter && submitter.name === 'add' && submitter.closest('.test-modal')) {
          e.preventDefault();
          e.stopImmediatePropagation();
          handleHeroModalBooking(submitter);
        }
      }, true);
    });

    document.querySelectorAll('.test-modal [name="add"].add-to-cart span[data-add-to-cart-text]').forEach(function (span) {
      span.textContent = 'Continue to booking';
    });
  }

  function wireServeAnchorLinks() {
    document.querySelectorAll('a[href="#iron-where-we-serve"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.getElementById('iron-where-we-serve');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) {
          history.replaceState(null, '', '#iron-where-we-serve');
        }
      });
    });
  }

  function positionServeLinkUnderBookNow() {
    var wrap = document.querySelector('.iron-serve-link-wrap');
    var btn = document.querySelector('#custom__product-variant-desk .easy_appointment_custom, .featured-product .easy_appointment_custom');
    if (!wrap || !btn) return;
    if (btn.nextElementSibling === wrap) return;

    var originalBlock = wrap.closest('.product-block');
    var container = btn.parentNode;

    btn.parentNode.insertBefore(wrap, btn.nextSibling);

    wrap.style.display = 'block';
    wrap.style.width = btn.offsetWidth + 'px';
    wrap.style.textAlign = 'center';
    wrap.style.marginTop = '8px';
    wrap.style.marginBottom = '0';

    btn.style.verticalAlign = 'top';

    if (originalBlock && !originalBlock.textContent.trim()) {
      originalBlock.style.display = 'none';
    }
  }

  function waitForBookButtonAndPositionLink() {
    var attempts = 0;
    var max = 80;
    var tick = function () {
      positionServeLinkUnderBookNow();
      var wrap = document.querySelector('.iron-serve-link-wrap');
      var btn = document.querySelector('#custom__product-variant-desk .easy_appointment_custom, .featured-product .easy_appointment_custom');
      if ((!wrap || !btn || btn.nextElementSibling !== wrap) && attempts < max) {
        attempts++;
        setTimeout(tick, 250);
      }
    };
    tick();
  }

  function initIronMain() {
    if (window.__dgIronMainInit || !isMainIronPage()) return;
    window.__dgIronMainInit = true;
    wireHeroBookingBridge();
    wireServeAnchorLinks();
    waitForBookButtonAndPositionLink();
    document.querySelectorAll('.test-modal').forEach(reorderHeroModalOptions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIronMain);
  } else {
    initIronMain();
  }
  document.addEventListener('page:loaded', initIronMain);
})();
